/**
 * KBNL-141 (코드 리뷰): 저장된 names + meta([{name, owner_user_id}])를
 * 'owner::name' 복합 키 배열로 복원한다.
 *
 * 백엔드 _owner_pairs 와 동일한 FIFO 방식 — 같은 name 이 서로 다른 owner 로 여러 번
 * 있어도(예: alice::Sales, bob::Sales) 순서대로 각자 owner 와 매칭해 둘 다 보존한다.
 * (Map(name->owner) 방식은 마지막 owner 만 남아 Set 에서 1개로 줄어드는 버그가 있었음)
 *
 * @param {string[]} names  저장된 이름 목록(순서 = UI 가 저장 시 만든 순서)
 * @param {Array<{name?:string, owner_user_id?:string, user_id?:string}>} meta
 * @returns {string[]} 'owner::name' 키 배열 (owner 미상은 '::name')
 */
export function restoreSelectionKeys(names, meta) {
  const buckets = new Map()  // name -> owner 큐(FIFO)
  for (const m of (meta || [])) {
    const nm = (m?.name || '').trim()
    const ow = (m?.owner_user_id || m?.user_id || '').trim()
    if (nm && ow) {
      if (!buckets.has(nm)) buckets.set(nm, [])
      buckets.get(nm).push(ow)
    }
  }
  return (names || []).map(n => {
    const q = buckets.get(n)
    const owner = (q && q.length) ? q.shift() : ''
    return `${owner}::${n}`
  })
}
